export const emptyList = [];
export const emptyObject = {};
